<template>
  <div class="app-container" style="display:flow-root">
    <el-form v-if="orderDraft" label-width="180px">
      <draft-index
        :initializing="initializing"
        :order-draft="orderDraft"
        :settings="settings"
        style="margin-bottom:10px"
        @row-dblclick="draftClick"
        @saved="onSaved"
      />
      <draft-editor
        v-if="selectedOrderLineDraft"
        :selected-order-line-draft="selectedOrderLineDraft"
        :general-finishes="generalFinishes"
        :grommets="grommets"
        :settings="settings"
      />
    </el-form>
  </div>
</template>

<script>
import DraftIndex from './Components/DraftIndex';
import DraftEditor from './Components/DraftEditor';

export default {
  name: 'OrderDraftEditor',
  components: {
    DraftIndex,
    DraftEditor
  },
  data() {
    return {
      initializing: false,
      orderDraft: null,
      selectedOrderLineDraft: null,
      finishDictionary: {},
      generalFinishes: [],
      grommets: [],
      orderHasChanged: undefined,
      settings: null
    };
  },
  computed: {},
  watch: {
    orderDraft: {
      deep: true,
      handler: function(value) {
        if (this.orderHasChanged !== undefined) {
          this.orderHasChanged = true;
        } else {
          this.orderHasChanged = false;
        }
      }
    }
  },
  async created() {
    window.addEventListener('beforeunload', this.beforeUnload, false);

    const settings = await this.$store.dispatch('interiorDecoratorOrder/getSettings');
    this.settings = settings;

    const id = this.$route.params && this.$route.params.id;
    if (id) {
      this.initializing = true;
      this.$store
        .dispatch('orderDraft/getItem', { selector: { id } })
        .then(orderDraftDTO => {
          const item = this.convertDtoToItem(orderDraftDTO);
          this.orderDraft = item;
          if (item.orderLines.length > 0) {
            this.selectedOrderLineDraft = item.orderLines[0];
          }
        })
        .finally(() => {
          this.initializing = false;
          this.orderHasChanged = false;
        });
    } else {
      this.orderDraft = {
        deliverAtHomeYN: settings.deliverAtHomeYN,
        consumer: {
          name: undefined,
          email: undefined,
          phone: undefined,
          street: undefined,
          houseNumber: undefined,
          postalCode: undefined,
          city: undefined,
          countryCode: 'NL'
        },
        orderLines: []
      };
    }

    this.$store.dispatch('country/getItems');
    this.$store.dispatch('special/getItems', {
      query: {
        activeYN: true
      }
    });
    this.$store.dispatch('interiorDecoratorOrder/getGeneralFinishes').then(data => (this.generalFinishes = data));
    this.$store.dispatch('interiorDecoratorOrder/getGrommets').then(data => (this.grommets = data));
  },
  methods: {
    convertDtoToItem(dto) {
      const orderLines = [];
      if (dto.orderLines) {
        dto.orderLines.forEach(item => {
          const line = {
            ...item,
            errors: []
          };

          const curtain = line.curtain;
          if (curtain) {
            if (curtain.railLengthInCm === null) {
              curtain.railLengthInCm = undefined;
            }
            if (curtain.widthLeftInCm === null) {
              curtain.widthLeftInCm = undefined;
            }
            if (curtain.widthRightInCm === null) {
              curtain.widthRightInCm = undefined;
            }
            if (curtain.heightInCm === null) {
              curtain.heightInCm = undefined;
            }
          }

          const romanBlind = item.romanBlind;
          if (romanBlind) {
            if (romanBlind.widthInCm === null) {
              romanBlind.widthInCm = undefined;
            }
            if (romanBlind.heightInCm === null) {
              romanBlind.heightInCm = undefined;
            }
          }

          const embrace = item.embrace;
          if (embrace) {
            if (embrace.widthInCm === null) {
              embrace.widthInCm = undefined;
            }
          }

          orderLines.push(line);
        });
        dto.orderLines = orderLines;
      }
      return dto;
    },
    draftClick(row) {
      if (row) {
        this.getFinishes(row.productGroupID);
      }
      this.selectedOrderLineDraft = row;
    },
    onSaved() {
      this.orderHasChanged = false;
    },
    getFinishes(productGroupID) {
      if (productGroupID) {
        const productGroupFinishes = this.finishDictionary[productGroupID];
        if (!productGroupFinishes) {
          this.$store
            .dispatch('interiorDecoratorOrder/getProductGroupFinishes', {
              productGroupID: productGroupID
            })
            .then(data => {
              this.finishDictionary[productGroupID] = data;
              this.currentFinishesAvailable = data;
              this.$forceUpdate();
            });
        } else {
          this.currentFinishesAvailable = productGroupFinishes;
          this.$forceUpdate();
        }
      }
    },
    beforeUnload(e) {
      if (this.orderHasChanged) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.orderHasChanged) {
      this.$store
        .dispatch('notify/confirm', { message: this.$i18n.t('orderDraft.leaveWithoutSaving') })
        .then(() => {
          next();
        })
        .catch(() => {});
    } else {
      next();
    }
  }
};
</script>
<style lang="scss"></style>
